module.exports = __webpack_public_path__ + "media/images/flags/cz-870ef3b969939abef2b6360b772063c5.svg";